var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInactiveUserBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    rx: 8,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2598 22.0199V26.9899C16.2598 28.8099 16.2598 28.8099 17.9798 29.9699L22.7098 32.6999C23.4198 33.1099 24.5798 33.1099 25.2898 32.6999L30.0198 29.9699C31.7398 28.8099 31.7398 28.8099 31.7398 26.9899V22.0199C31.7398 20.1999 31.7398 20.1999 30.0198 19.0399L25.2898 16.3099C24.5798 15.8999 23.4198 15.8999 22.7098 16.3099L17.9798 19.0399C16.2598 20.1999 16.2598 20.1999 16.2598 22.0199Z",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M29.5 18.63V16C29.5 14 28.5 13 26.5 13H21.5C19.5 13 18.5 14 18.5 16V18.56",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M24.6298 21.99L25.1998 22.88C25.2898 23.02 25.4898 23.16 25.6398 23.2L26.6598 23.46C27.2898 23.62 27.4598 24.16 27.0498 24.66L26.3798 25.47C26.2798 25.6 26.1998 25.83 26.2098 25.99L26.2698 27.04C26.3098 27.69 25.8498 28.02 25.2498 27.78L24.2698 27.39C24.1198 27.33 23.8698 27.33 23.7198 27.39L22.7398 27.78C22.1398 28.02 21.6798 27.68 21.7198 27.04L21.7798 25.99C21.7898 25.83 21.7098 25.59 21.6098 25.47L20.9398 24.66C20.5298 24.16 20.6998 23.62 21.3298 23.46L22.3498 23.2C22.5098 23.16 22.7098 23.01 22.7898 22.88L23.3598 21.99C23.7198 21.45 24.2798 21.45 24.6298 21.99Z",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveUserBadge);
export default __webpack_public_path__ + "static/media/inactiveUserBadge.196237e5acfa7022b69d08b62bd3bfba.svg";
export { ForwardRef as ReactComponent };